/**
 * Regras de negócio que são um número fixo (ou uma exceção combinada), num lugar só.
 *
 * Lê: nada.
 * Usado por: dominio/painel.ts, dominio/fechamento.ts, telas/montar-graficos.ts e telas/Metas.tsx.
 */
import type { DataIso, Fonte, Mes } from './tipos.ts';

/**
 * Supermeta: 5% acima da meta, para todos (Isabella também).
 * Resposta da gerente em 12/10/2026: "5% crescimento em cima da meta".
 */
export const SUPERMETA_PERCENTUAL = 0.05;

/**
 * Situações cadastrais que contam na carteira de um representante (para o
 * "% da carteira atendida"). Bloqueado e Excluído ficam de fora: não podem comprar.
 * (A conferir com a gerente; mudar aqui muda a conta inteira.)
 */
export const SITUACOES_DA_CARTEIRA = ['Normal', 'Novo'] as const;

/**
 * Meses em que uma fonte NÃO fechou do dia 1º ao último dia do mês (exceções
 * combinadas com a gerente). Mês que não está aqui fecha no calendário.
 * O mês seguinte a uma exceção começa no dia depois do fim dela (dominio/fechamento.ts).
 */
export const FECHAMENTOS_ESPECIAIS: Partial<Record<Fonte, Record<Mes, { inicio: DataIso; fim: DataIso }>>> = {
  'sap-bauny': {
    // Setembro/2026: as notas de 01/10 contaram em setembro (exceção; respostas da gerente
    // de 12/10/2026 e aba BAUNY da planilha dela). Por isso a Bauny de outubro começa em 02/10
    // (confirmado por ela em 12/10/2026: "sim").
    '2026-09': { inicio: '2026-09-01', fim: '2026-10-01' },
  },
};
